<template>
    <div class="video" :style="{ backgroundImage: 'url(' + bgsrc + ')' }" data-aos="fade-up">
        <div class="inside">
        <p> aaaaaaaaa </p>
        </div>
    </div>
</template>

<script>
    import store from '../store/store';
    export default {
        name: 'video-box',
        props: ['bgsrc', 'videosrc'],
        data() {
            return {}
        },
        methods: {
            showVideoModal: function(src) {
                store.commit('OPEN_VIDEO_MODAL', src);
            }
        },
        computed: {
            lang: () => {
                return store.state.lang;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// VideoBox.vue?3de571b5